export var HISTORICAL_VIEW = "HISTORICAL_VIEW";
